import { Component } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';

interface PreguntaFrecuente {
  titulo: string;
  contenido: string;
  valor: number;
}

@Component({
  selector: 'allas-faqs-baterias',
  imports: [AccordionModule],
  template: `
    <section class="px-4 py-8">
      <!-- Titulo Beneficios del Programa -->
      <h2
        class="text-xl xl:text-4xl mb-2 xl:mb-6 mt-2 xl:mt-8 font-bold fs-condensed"
      >
        PREGUNTAS FRECUENTES
      </h2>

      <div>
        <p-accordion [value]="0" class="w-full">
          @for (pregunta of preguntas; track pregunta.valor) {
          <p-accordion-panel [value]="pregunta.valor">
            <p-accordion-header>
              <span
                class="text-sm xl:text-lg font-semibold fs-condensed text-gray-800"
              >
                {{ pregunta.titulo }}
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <div>
                <p
                  class="m-0 text-xs xl:text-base"
                  [innerHTML]="pregunta.contenido"
                ></p>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
          }
        </p-accordion>
      </div>
    </section>
  `,
})
export class FaqsBaterias {
  preguntas: PreguntaFrecuente[] = [
    {
      titulo: '¿Qué servicios de baterías ofrece ALLAS Repuestos?',
      contenido:
        'ALLAS Repuestos ofrece tres servicios de batería gratuitos. Pasa por cualquier tienda para probar, cargar o reciclar su batería.',
      valor: 0,
    },
    {
      titulo: '¿Qué sucede durante una prueba de batería en ALLAS Repuestos?',
      contenido:
        'Si cree que podría tener una batería defectuosa, visite cualquier tienda ALLAS Repuestos cercana y solicite una prueba de batería gratuita. Un asesor de ALLAS Repuestos irá a su vehículo y usará un probador de batería para obtener una lectura del estado de su batería. Si su batería tiene poca energía, pero aún está en buen estado, la cargaremos de nuevo de forma gratuita. Si es superado, le ayudaremos a encontrar una nueva.',
      valor: 1,
    },
    {
      titulo: '¿ALLAS Repuestos reemplazará su batería?',
      contenido:
        '¡Sí! Vaya a la tienda ALLAS Repuestos más cercana para que prueben su batería de forma gratuita. Si el informe muestra que tienes una batería defectuosa, te ayudaremos a encontrar una nueva.',
      valor: 2,
    },
    {
      titulo: '¿Cuánto cuesta cargar una batería en ALLAS Repuestos?',
      contenido:
        'Puede cargar su batería de forma gratuita en cualquier tienda ALLAS Repuestos.',
      valor: 3,
    },
    {
      titulo: '¿ALLAS Repuestos recicla las baterías?',
      contenido:
        'Sí, lo hacemos. Es parte de nuestro compromiso de ayudar al medio ambiente. Y lo mejor de todo es que reciclaremos su batería de forma gratuita en cualquier tienda ALLAS Repuestos.',
      valor: 4,
    },
    {
      titulo: '¿Puedo comprar una batería de ALLAS Repuestos en línea?',
      contenido:
        '¡Absolutamente! Contamos con una amplia variedad de baterías en línea para que pueda encontrar la adecuada para usted y volver a la carretera. Recomendamos consultar las baterías "TAB Batteries" la mejor opción de batería de Honduras.',
      valor: 5,
    },
  ];
}
